module.exports = __webpack_public_path__ + "static/twanb-icon-3522005e2cbc5b772b00de2168972c20.png";